/**
 * Error codes returned by `GET /config/consents/primary` in the `detail.code` field, and a helper to read them.
 * See family-portal-api `app/config/exceptions.py`.
 */
export const CONSENT_TO_TESTING_NOT_APPLICABLE = 'CONSENT_TO_TESTING_NOT_APPLICABLE'
export const MULTIPLE_PENDING_ORDERS = 'MULTIPLE_PENDING_ORDERS'

/**
 * Reads `detail.code` from a family-portal-api error response, or undefined when absent/unparseable.
 * Consumes the response body, so call only on a response you will not read again.
 */
export async function readConsentErrorCode(res: Response): Promise<string | undefined> {
  try {
    const body = (await res.json()) as { detail?: { code?: string } | string | null }
    const detail = body?.detail
    if (detail && typeof detail === 'object') return detail.code ?? undefined
  } catch {
    // non-JSON or empty error body — no code to surface
  }
  return undefined
}
